<template>
  <section class="section is-marginless">
    <div class="columns is-centered">
      <div class="column">
        <h3 class="subtitle">Who would you like to invite?</h3>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-half">
        <router-link class="button is-outlined is-medium is-primary is-fullwidth" :to="{name: 'InviteUser', query: query_string}">Invite Customer</router-link>
      </div>
      <div class="column is-half">
        <router-link class="button is-outlined is-medium is-primary is-fullwidth" :to="{name: 'InviteDriver', query: query_string}">Invite Driver</router-link>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'InviteSelection',
    data () {
      return {
        query_string: this.$route.query
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/invite/InviteSelection.vue